import { IconCheck, IconX } from '@tabler/icons-react'
import styled from 'styled-components'

import { Button } from '@/components/shared-components/BUI/Button'
import { Text } from '@/components/shared-components/BUI/Text'
import { Flexbox } from '@/components/shared-components/Flexbox'
import { useBreakpoint } from '@/hooks/useBreakpoint'

const IconCircleContainer = styled.div`
  border-radius: 50%;
  padding: 1.5rem;
  border: 1px solid ${({ theme }) => theme.colour.primary._500};
  color: ${({ theme }) => theme.colour.primary._500};
  display: flex;
  align-items: center;
  justify-content: center;
`

export const SuccessContent = ({
  onClose,
  onSubmitAnother,
}: {
  onClose: () => void
  onSubmitAnother?: () => void
}) => {
  const isSmall = useBreakpoint('lg')

  return (
    <>
      {!isSmall && (
        <Flexbox
          flexDirection="row"
          justifyContent="flex-end"
          style={{ width: '100%', minHeight: '1rem' }}
        >
          <Button
            variant="ghost"
            icon={<IconX size={16} />}
            onClick={onClose}
            style={{ marginLeft: 'auto' }}
          />
        </Flexbox>
      )}
      <Flexbox
        flexDirection="column"
        gap="1.5rem"
        alignItems="center"
        justifyContent="center"
      >
        <IconCircleContainer>
          <IconCheck size={16} />
        </IconCircleContainer>
        <Flexbox flexDirection="column" alignItems="center" gap="0.5rem">
          <Text variant="subheading01">Feedback submitted</Text>
          <Text variant="caption01" secondary="_500">
            Thanks for sharing!
          </Text>
        </Flexbox>
        <Button variant="secondary" onClick={onSubmitAnother}>
          Submit more feedback
        </Button>
      </Flexbox>
    </>
  )
}
